import {FC} from 'react';
//mui
import {FormHelperText as MuiFormHelperText, FormHelperTextProps} from '@mui/material';

interface ExtendedFormHelperTextProps extends FormHelperTextProps {
	title: string;
}

const FormHelperText: FC<ExtendedFormHelperTextProps> = ({title, ...rest}) => {
	return <MuiFormHelperText {...rest}>{title}</MuiFormHelperText>;
};

export default FormHelperText;
